"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var form_item_1 = __importDefault(require("../form-item"));
var react_intl_1 = require("react-intl");
var RequirementsUtility_1 = require("../../../utils/RequirementsUtility");
// import {FormInstance} from "antd/es/form";
var translationMessages = {
    baseInformation_costCenter: {
        id: "baseInformation_costCenter",
        defaultMessage: "Cost center",
    },
    baseInformation_costCenter_placeholder_input: {
        id: "baseInformation_costCenter_placeholder_input",
        defaultMessage: "Input you cost center",
    },
    baseInformation_costCenter_placeholder_search: {
        id: "baseInformation_costCenter_placeholder_search",
        defaultMessage: "Search cost centers",
    },
};
//
// const handleReferenceIdentifierValueSearch = (
//     searchValue: string,
//     costCenterFieldDefinition: FieldDefinition,
//     receiverRequirements: NewReceiverRequirements,
//     rapiBaseUrl: string,
//     setLoadingCostCenterValues: (loadingCostCenterValues: boolean) => void,
//     updateReceiverRequirementsProp: (receiverRequirements: NewReceiverRequirements) => void
// ) => {
//     if (costCenterFieldDefinition && costCenterFieldDefinition.properties && costCenterFieldDefinition.properties.href) {
//         const searchUrl = rapiBaseUrl + costCenterFieldDefinition.properties.href.replace("%7BtextFilter%7D", searchValue).replace("%7Boffset%7D", "0").replace("%7Blimit%7D", "15");
//         setLoadingCostCenterValues(true)
//         axios.get(searchUrl)
//             .then(response => {
//                     setLoadingCostCenterValues(false)
//                     const updatedFieldDefinitions: FieldDefinition[] = [...receiverRequirements.fieldDefinitions];
//                     const index = updatedFieldDefinitions.findIndex(x => x.key === costCenterFieldDefinition.key)
//
//                     const updatedReferenceIdentifier: FieldDefinition = {
//                         ...updatedFieldDefinitions[index],
//                         properties: {
//                             label: updatedFieldDefinitions[index].properties.label,
//                             href: updatedFieldDefinitions[index].properties.href,
//                             cardinality: updatedFieldDefinitions[index].properties.cardinality,
//                             values: response.data.value
//                         }
//                     };
//                     updatedFieldDefinitions.splice(index, 1, updatedReferenceIdentifier)
//
//                     const newReceiverRequirements: NewReceiverRequirements = {
//                         ...receiverRequirements,
//                         fieldDefinitions: updatedFieldDefinitions
//                     }
//
//                     updateReceiverRequirementsProp(newReceiverRequirements);
//                 }
//             )
//             .catch(error => {
//                 setLoadingCostCenterValues(false)
//             })
//
//     }
// }
//
// const getCostCenterInput = (
//     fieldDefinition: FieldDefinition,
//     receiverRequirements: NewReceiverRequirements,
//     rapiBaseUrl: string,
//     setLoadingCostCenterValues: (loadingCostCenterValues: boolean) => void,
//     loadingCostCenterValues: boolean,
//     updateReceiverRequirementsProp: (receiverRequirements: NewReceiverRequirements) => void,
//     constCenterPlaceholderInput: string,
//     constCenterPlaceholderSearch: string,
// ): React.ReactElement => {
//     let handling = null;
//     if (fieldDefinition.properties.handling) {
//         handling = JSON.parse(fieldDefinition.properties.handling)
//     }
//
//     if (fieldDefinition) {
//         if (fieldDefinition.properties.values) {
//             const selectProps: SelectProps<any> = fieldDefinition.properties.hasOwnProperty("href")
//                 ? {
//                     showSearch: true,
//                     filterOption: false,
//                     onSearch: (searchValue: string) => {
//                         handleReferenceIdentifierValueSearch(searchValue, fieldDefinition, receiverRequirements, rapiBaseUrl, setLoadingCostCenterValues, updateReceiverRequirementsProp);
//                     },
//                     onChange: (searchValue: string) => {
//                         if (!searchValue) {
//                             handleReferenceIdentifierValueSearch("", fieldDefinition, receiverRequirements, rapiBaseUrl, setLoadingCostCenterValues, updateReceiverRequirementsProp);
//                         }
//                     },
//                     loading: loadingCostCenterValues,
//                 }
//                 : {}
//
//             return <Select
//                 dropdownMatchSelectWidth={false}
//                 allowClear
//                 {...selectProps}
//                 placeholder={getFieldPlaceholderOverride(receiverRequirements,AvailableFields["customer.locationIdentifier"], constCenterPlaceholderSearch)}
//             >
//                 {fieldDefinition.properties.values.map(op => {
//                         return <Select.Option
//                             key={op.key}
//                             value={op.key}
//                         >
//                             {op.name}
//                         </Select.Option>;
//                     }
//                 )}
//             </Select>;
//         } else {
//             return <Input
//                 placeholder={getFieldPlaceholderOverride(receiverRequirements,AvailableFields["customer.locationIdentifier"], constCenterPlaceholderInput)}/>
//         }
//     } else {
//         return <Input
//             placeholder={getFieldPlaceholderOverride(receiverRequirements,AvailableFields["customer.locationIdentifier"], constCenterPlaceholderInput)}/>
//     }
// }
var CostCenter = function (props) {
    var _a = react_1.useState(""), costCenterHandlingValidationStatus = _a[0], setCostCenterHandlingValidationStatus = _a[1];
    var _b = react_1.useState({}), costCenterFieldProps = _b[0], setCostCenterFieldProps = _b[1];
    var _c = react_1.useState(false), loadingCostCenterValues = _c[0], setLoadingCostCenterValues = _c[1];
    var costCenterFieldDefinition = RequirementsUtility_1.getFieldRequirements(props.receiverRequirements, ReceiverRequirements_1.AvailableFields["customer.locationIdentifier"]);
    if (costCenterFieldDefinition) {
        return (react_1.default.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["customer.locationIdentifier"], defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_costCenter), defaultIsRequired: false, fieldName: ["invoice", "customer", "locationIdentifier"], validateStatus: costCenterHandlingValidationStatus }, RequirementsUtility_1.getInput(costCenterFieldDefinition, ["invoice", "customer", "locationIdentifier"], "handleCostCenterValidation", props.legalIdentifier, props.formInstance, props.rapiBaseUrl, props.receiverRequirements, props.updateReceiverRequirementsProp, setCostCenterFieldProps, costCenterFieldProps, setLoadingCostCenterValues, loadingCostCenterValues, setCostCenterHandlingValidationStatus, true)));
    }
    else {
        return null;
    }
};
exports.default = react_intl_1.injectIntl(CostCenter);
